import React from "react";
import PropTypes from "prop-types";
import { CheckCircle, Error } from "@mui/icons-material";

import Modal from "components/common/Modal";
import Button from "components/common/Button";

import "./CreateOneTimeChargeModal.scss";

function ResultModal({ open, onClose, onAction, type = "success", errorMessage }) {
  const modalConfig = {
    success: {
      icon: <CheckCircle sx={{ fontSize: 40, color: "var(--color-primitives-success-600)" }} />,
      title: "Charge created successfully",
      description:
        "Your one-time charge has been created and is now being processed. The customer will be billed shortly.",
      additionalInfo: "You can view the details in the payment history section.",
      primaryButtonLabel: "View Charge",
      secondaryButtonLabel: "Close",
    },
    error: {
      icon: <Error sx={{ fontSize: 40, color: "var(--color-primitives-danger-600)" }} />,
      title: "Unable to create charge",
      description:
        errorMessage ||
        "Something went wrong and the charge couldn't be created. Please try again or contact support if the issue persists.",
      primaryButtonLabel: "Create New Charge",
      secondaryButtonLabel: "Close",
    },
  };

  const config = modalConfig[type];

  return (
    <Modal open={open} onClose={onClose} width="456px" padding="24px">
      <div className="result-modal-content">
        <div className="result-modal-icon-container mb-1">{config.icon}</div>

        <h1 className="heading-h1-semibold result-modal-title">{config.title}</h1>

        <p className="para-body-m-regular color-text-body-primary result-modal-description">{config.description}</p>

        {type === "success" && (
          <p className="para-body-m-regular color-text-body-primary result-modal-additional-info pt-1">
            {config.additionalInfo}
          </p>
        )}

        <div className="result-modal-actions t-1">
          <Button variant="text" size="large" onClick={onClose} label={config.secondaryButtonLabel} />
          <Button variant="contained" size="large" onClick={onAction} label={config.primaryButtonLabel} />
        </div>
      </div>
    </Modal>
  );
}

ResultModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAction: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["success", "error"]),
  errorMessage: PropTypes.string,
};

ResultModal.defaultProps = {
  type: "success",
  errorMessage: "",
};

export default ResultModal;
